/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setloading, notloading } from "../../actions";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import MUIDataTable from "mui-datatables";
import { faMedkit } from "@fortawesome/free-solid-svg-icons";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import {
  Button,
  Grid,
  Paper,
  Typography,
  InputBase,
  IconButton,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 2),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 300,
  },
  dense: {
    marginTop: 19,
  },
  paper1: {
    padding: "2px",
  },
  margin: {
    margin: theme.spacing(1),
  },
  marginr: {
    marginRight: 4,
  },
}));
const Diagnosis = (props) => {
  const dispatch = useDispatch();
  //  const CaseId = props.location.state.CaseId;
  /// const PatientName = props.location.state.PatientName;
  const CaseId = props.CaseId;
  const PatientName = props.PatientName;
  const [rowsSurgical, setRowsSurgical] = useState([]);
  const [rowsSurgicalAdded, setRowsSurgicalAdded] = useState([]);

  var settingsE = localStorage.getItem("settings");
  var settings = CryptoAES.decrypt(settingsE.toString(), "cbs211&213&215");
  var s = JSON.parse(settings.toString(CryptoENC));
  const serverUrl = s.serverUrl;
  const facilityname = s.facilityName;

  var userdetails = localStorage.getItem("userdetails");
  var udetails = CryptoAES.decrypt(userdetails.toString(), "cbs211&213&215");
  var u = JSON.parse(udetails.toString(CryptoENC));

  const userFullname = u.userFullname;
  const [firstLoad, setfirstLoad] = useState(true);
  const [rowsSelected, setrowsSelected] = useState([]);
  const [rowsSelectedAdded, setrowsSelectedAdded] = useState([]);
  useEffect(() => {
    if (firstLoad) {
      if (CaseId !== "") {
        handleGetDiagnosisPerAdmission();
      }
      setfirstLoad(false);
    }
  }, [firstLoad]);

  const classes = useStyles();

  const [values, setValues] = React.useState({
    Diagnosis: "",
  });

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const columnsSurgicalOperations = [
    {
      name: "disease",
      label: "Disease",
      options: {
        display: "true",
        filter: false,
      },
    },
    {
      name: "icdcode",
      label: "Icd Code",
      options: {
        display: "true",
        filter: false,
      },
    },
    {
      name: "Id",
      label: "Id",
      options: {
        display: "false",
        filter: false,
      },
    },
    {
      name: "icdcat",
      label: "Icd Category",
      options: {
        display: "true",
        filter: false,
      },
    },
  ];

  const columnsSurgicalOperationsAdded = [
    {
      name: "disease",
      label: "Disease",
      options: {
        display: "true",
        filter: false,
      },
    },
    {
      name: "Code",
      label: "Icd Code",
      options: {
        display: "true",
        filter: false,
      },
    },
    {
      name: "Id",
      label: "Id",
      options: {
        display: "false",
        filter: false,
      },
    },
    {
      name: "IcdCat",
      label: "Icd Category",
      options: {
        display: "true",
        filter: false,
      },
    },
  ];

  const optionsSurgicalOperations = {
    filterType: "dropdown",
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    selectableRows: "single",
    selectableRowsOnClick: true,
    serverSide: false,
    pagination: false,
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) =>
      customToolbarSelect(selectedRows, displayData, setSelectedRows),
    responsive: "scrollMaxHeight",
    rowsPerPage: 100,
    rowsSelected: rowsSelected,
    onRowsSelect: (rowsSelected, allRows) => {
      setrowsSelected(allRows.map((row) => row.dataIndex));
    },
    expandableRows: false,
  };

  const optionsSurgicalOperationsAdded = {
    filterType: "dropdown",
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    selectableRows: "single",
    selectableRowsOnClick: true,
    serverSide: false,
    pagination: false,
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) =>
      customToolbarSelectAdded(selectedRows, displayData, setSelectedRows),
    responsive: "scrollMaxHeight",
    rowsPerPage: 100,
    rowsSelected: rowsSelectedAdded,
    onRowsSelect: (rowsSelected, allRows) => {
      setrowsSelectedAdded(allRows.map((row) => row.dataIndex));
    },
    expandableRows: false,
  };

  const handleAddDiagnosis = (code, category) => {
    dispatch(setloading());

    const valuestosave = {
      code: code,
      category: category,
      userFullname: userFullname,
      CaseId: CaseId,
    };

    axios
      .post(serverUrl + "/api/savediagnosisperadmission", valuestosave)
      .then((res) => {
        if (res.data.Status === 1) {
          Swal.fire({
            title: facilityname,
            text: res.data.Message,
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              handleGetDiagnosisPerAdmission();
              dispatch(notloading());
              //  props.history.push("/patients");
            }
          });
        } else {
          dispatch(notloading());
          Swal.fire({
            title: facilityname,
            text: res.data.Message,
            type: "warning",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
          });
        }
      })
      .catch((error) => {
        dispatch(notloading());

        Swal.fire({
          title: facilityname,
          text: "Error" + error,
          type: "warning",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });
      })
      .finally(function () {});
  };

  const customToolbarSelect = (selectedRows, displayData, setSelectedRows) => {
    const newSelectedRow = selectedRows.data[selectedRows.data.length - 1];
    const selectedData = displayData[newSelectedRow.index];
    const code = selectedData.data[1];
    const category = selectedData.data[3];
    return (
      <div>
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.margin}
          onClick={() => handleAddDiagnosis(code, category)}
        >
          <FontAwesomeIcon icon={faMedkit} className={classes.marginr} />
          Add to Patient's Diagnosis
        </Button>
      </div>
    );
  };

  const customToolbarSelectAdded = (
    selectedRows,
    displayData,
    setSelectedRows
  ) => {
    const newSelectedRow = selectedRows.data[selectedRows.data.length - 1];
    const selectedDataAdded = displayData[newSelectedRow.index];

    let proc = "";
    if (selectedDataAdded != null) {
      proc = selectedDataAdded.data[2];
    }

    return (
      <div>
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.margin}
          onClick={() => handleDeleteDiagnosis(proc)}
        >
          <FontAwesomeIcon icon={faTrash} className={classes.marginr} />
          Delete
        </Button>
      </div>
    );
  };

  const handleDeleteDiagnosis = (proc) => {
    dispatch(setloading());
    console.log(proc);

    const valuestosave = {
      userFullname: userFullname,
      Id: proc,
    };

    axios
      .post(serverUrl + "/api/deletediagnosis", valuestosave)
      .then((res) => {
        if (res.data.Status === 1) {
          Swal.fire({
            title: facilityname,
            text: res.data.Message,
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              handleGetDiagnosisPerAdmission();
              dispatch(notloading());
              //  props.history.push("/patients");
            }
          });
        } else {
          dispatch(notloading());
          Swal.fire({
            title: facilityname,
            text: res.data.Message,
            type: "warning",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
          });
        }
      })
      .catch((error) => {
        dispatch(notloading());

        Swal.fire({
          title: facilityname,
          text: "Error" + error,
          type: "warning",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });
      })
      .finally(function () {});
  };

  const handleSearchSurgicalOperations = () => {
    dispatch(setloading());

    var serverUrl = localStorage.getItem("serverUrl");
    var token = localStorage.getItem("token_id");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;

    axios
      .get(serverUrl + "/api/searchdiagnosis", {
        params: {
          searchStr: values.Diagnosis,
        },
      })
      .then((res) => {
        setRowsSurgical(res.data.lst);

        dispatch(notloading());
      })

      .catch((error) => {
        Swal.fire({
          title: facilityname,
          text: "Error" + error,
          type: "error",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });
      });
  };

  const handleGetDiagnosisPerAdmission = () => {
    dispatch(setloading());
    var serverUrl = localStorage.getItem("serverUrl");
    var token = localStorage.getItem("token_id");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios
      .get(serverUrl + "/api/getdiagnosisperadmission", {
        params: {
          CaseId: CaseId,
        },
      })
      .then((res) => {
        setRowsSurgicalAdded(res.data.lst);

        dispatch(notloading());
      })

      .catch((error) => {
        Swal.fire({
          title: facilityname,
          text: "Error" + error,
          type: "error",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });
      });
  };

  return (
    <div>
      <Paper className={classes.root}>
        <Typography variant="h6" component="h6" align="center">
          Diagnosis for patient {PatientName}
        </Typography>
        <div className={classes.wrapper}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Paper className={classes.root}>
                <Paper className={classes.paper1}>
                  <InputBase
                    className={classes.input}
                    placeholder="Search Diagnosis"
                    inputProps={{ "aria-label": "search diagnosis" }}
                    style={{ width: 300 }}
                    id="Diagnosis"
                    name="Diagnosis"
                    value={values.Diagnosis}
                    onChange={handleChange("Diagnosis")}
                  />
                  <IconButton
                    className={classes.iconButton}
                    aria-label="search"
                    onClick={() => handleSearchSurgicalOperations()}
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>

                <MUIDataTable
                  className={classes.margin}
                  title={"Diagnosis"}
                  data={rowsSurgical}
                  columns={columnsSurgicalOperations}
                  options={optionsSurgicalOperations}
                />
              </Paper>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Paper className={classes.root}>
                {/*      <Typography variant="h5" component="h3" align="center">
                    Added Surgical Operations
                  </Typography> */}

                <MUIDataTable
                  className={classes.margin}
                  title={"Added Diagnos(is/es)"}
                  data={rowsSurgicalAdded}
                  columns={columnsSurgicalOperationsAdded}
                  options={optionsSurgicalOperationsAdded}
                />
              </Paper>
            </Grid>
          </Grid>
        </div>
      </Paper>
    </div>
  );
};

export default withRouter(Diagnosis);
